import React, { useEffect, useState, useRef, useCallback } from "react";
import { motion } from "framer-motion";
import { timezones } from "../../utils/timezones.ts";
import { Link } from "react-router-dom";
import {
  FiBell,
  FiClock,
  FiGrid,
  FiLogOut,
  FiMoon,
  FiRadio,
  FiTrendingUp,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { SimplifiedFilters } from "../../components/dashboard/simplified-filters.tsx";
import { getUserToken } from "../../utils/helpers.js";
import { useAuth } from "../../contexts/AuthContext.tsx"

import SignalCard from "../../components/dashboard/SignalCard.tsx";
import AnalyticsModal from "../../components/dashboard/AnalyticsModal.tsx";

type DashboardProps = {
  preview?: boolean;
};

const PREVIEW_SIGNALS = [
  {
    pair: "EURUSD",
    pairNumber: "EURUSD",
    expiry: "5 min",
    time: "28/06/2026 10:15:00",
    originalTimestamp: "2026-06-28 08:15:00+00:00",
    signalType: "CALL",
    successRate: 87,
    marketCondition: { label: "Green - Trade", color: "green", percent: 87 },
    lastResults: [
      { Timestamp: "28/06/2026 10:10:00", "Predicted Signal": "CALL", "Market Signal": "CALL" },
      { Timestamp: "28/06/2026 10:05:00", "Predicted Signal": "PUT", "Market Signal": "PUT" },
    ],
    timezone: "Africa/Maputo",
  },
  {
    pair: "GBPUSD",
    pairNumber: "GBPUSD",
    expiry: "5 min",
    time: "28/06/2026 10:12:00",
    originalTimestamp: "2026-06-28 08:12:00+00:00",
    signalType: "PUT",
    successRate: 72,
    marketCondition: { label: "Green - Trade", color: "green", percent: 72 },
    lastResults: [
      { Timestamp: "28/06/2026 10:08:00", "Predicted Signal": "PUT", "Market Signal": "PUT" },
      { Timestamp: "28/06/2026 10:02:00", "Predicted Signal": "CALL", "Market Signal": "PUT" },
    ],
    timezone: "Africa/Maputo",
  },
  {
    pair: "USDCAD",
    pairNumber: "USDCAD",
    expiry: "5 min",
    time: "28/06/2026 10:09:00",
    originalTimestamp: "2026-06-28 08:09:00+00:00",
    signalType: "CALL",
    successRate: 91,
    marketCondition: { label: "Green - Trade", color: "green", percent: 91 },
    lastResults: [
      { Timestamp: "28/06/2026 09:58:00", "Predicted Signal": "CALL", "Market Signal": "CALL" },
      { Timestamp: "28/06/2026 09:45:00", "Predicted Signal": "CALL", "Market Signal": "CALL" },
    ],
    timezone: "Africa/Maputo",
  },
  {
    pair: "USDJPY",
    pairNumber: "USDJPY",
    expiry: "5 min",
    time: "28/06/2026 10:02:00",
    originalTimestamp: "2026-06-28 08:02:00+00:00",
    signalType: "CALL",
    successRate: 79,
    marketCondition: { label: "High Risk", color: "yellow", percent: 63 },
    lastResults: [
      { Timestamp: "28/06/2026 09:47:00", "Predicted Signal": "CALL", "Market Signal": "CALL" },
      { Timestamp: "28/06/2026 09:32:00", "Predicted Signal": "PUT", "Market Signal": "CALL" },
    ],
    timezone: "Africa/Maputo",
  },
  {
    pair: "CADCHF",
    pairNumber: "CADCHF",
    expiry: "5 min",
    time: "28/06/2026 10:18:00",
    originalTimestamp: "2026-06-28 08:18:00+00:00",
    signalType: "CALL",
    successRate: 93,
    marketCondition: { label: "Green - Trade", color: "green", percent: 93 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "EURJPY",
    pairNumber: "EURJPY",
    expiry: "5 min",
    time: "28/06/2026 10:17:00",
    originalTimestamp: "2026-06-28 08:17:00+00:00",
    signalType: "PUT",
    successRate: 68,
    marketCondition: { label: "Green - Trade", color: "green", percent: 68 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "EURUSD",
    pairNumber: "EURUSD",
    expiry: "5 min",
    time: "28/06/2026 10:16:00",
    originalTimestamp: "2026-06-28 08:16:00+00:00",
    signalType: "CALL",
    successRate: 76,
    marketCondition: { label: "Green - Trade", color: "green", percent: 76 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "GBPUSD",
    pairNumber: "GBPUSD",
    expiry: "5 min",
    time: "28/06/2026 10:14:00",
    originalTimestamp: "2026-06-28 08:14:00+00:00",
    signalType: "PUT",
    successRate: 64,
    marketCondition: { label: "High Risk", color: "yellow", percent: 64 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "USDCAD",
    pairNumber: "USDCAD",
    expiry: "5 min",
    time: "28/06/2026 10:13:00",
    originalTimestamp: "2026-06-28 08:13:00+00:00",
    signalType: "CALL",
    successRate: 83,
    marketCondition: { label: "Green - Trade", color: "green", percent: 83 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "USDJPY",
    pairNumber: "USDJPY",
    expiry: "5 min",
    time: "28/06/2026 10:11:00",
    originalTimestamp: "2026-06-28 08:11:00+00:00",
    signalType: "PUT",
    successRate: 71,
    marketCondition: { label: "Green - Trade", color: "green", percent: 71 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
  {
    pair: "CADCHF",
    pairNumber: "CADCHF",
    expiry: "5 min",
    time: "28/06/2026 10:10:00",
    originalTimestamp: "2026-06-28 08:10:00+00:00",
    signalType: "CALL",
    successRate: 88,
    marketCondition: { label: "Green - Trade", color: "green", percent: 88 },
    lastResults: [],
    timezone: "Africa/Maputo",
  },
];

const sidebarItems = [
  { label: "Dashboard", icon: FiGrid, to: "/dashboard/overview" },
  { label: "Sinais", icon: FiRadio, to: "/dashboard" },
  { label: "Historico", icon: FiClock, to: "/dashboard/history" },
  { label: "Resultados", icon: FiTrendingUp, to: "/dashboard/results" },
  { label: "Notificacoes", icon: FiBell, to: "/dashboard/notifications" },
  { label: "Comunidade", icon: FiUsers, to: "/dashboard/community" },
  { label: "Conta", icon: FiUser, to: "/dashboard/account" },
];

const previewSidebarRoutes: Record<string, string> = {
  Dashboard: "/dashboard-overview-preview",
  Sinais: "/dashboard-preview",
  Historico: "/dashboard-history-preview",
  Resultados: "/dashboard-results-preview",
  Notificacoes: "/dashboard-notifications-preview",
  Comunidade: "/dashboard-community-preview",
  Conta: "/dashboard-account-preview",
};

export function DashboardSidebar({
  active = "Sinais",
  preview = false,
}: {
  active?: string;
  preview?: boolean;
}) {
  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-[270px] border-r border-[#dfe8e1] bg-white px-4 py-5 xl:block">
      <div className="mb-9 flex items-center gap-3 px-2">
        <img src="/BB-icon.png" alt="" className="h-11 w-auto object-contain" />
        <span className="text-[22px] font-black tracking-[-0.03em] text-[#0d2a1f]">
          Binary<span className="text-[#20c77a]">Bucks</span>
        </span>
      </div>

      <nav className="space-y-1.5">
        {sidebarItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.label}
              to={preview ? previewSidebarRoutes[item.label] ?? item.to : item.to}
              className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-[15px] font-bold transition ${
                item.label === active
                  ? "bg-[#dff6ea] text-[#087a45]"
                  : "text-[#6f8178] hover:bg-[#f4f7f1] hover:text-[#0d2a1f]"
              }`}
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="absolute bottom-5 left-4 right-4 rounded-2xl border border-[#dfe8e1] bg-[#f4f7f1] p-4">
        <div className="mb-2 flex items-center gap-2 text-sm font-black text-[#0d2a1f]">
          <FiTrendingUp className="h-4 w-4 text-[#087a45]" />
          Plano Pro
        </div>
        <p className="mb-4 text-xs font-medium leading-relaxed text-[#73827b]">
          Desbloqueie alertas avancados e historico completo.
        </p>
        <button className="h-10 w-full rounded-full bg-[#20c77a] text-sm font-black text-[#03120e] transition hover:bg-[#18b56d]">
          Fazer upgrade
        </button>
      </div>
    </aside>
  );
}

export function DashboardTopbar() {
  return (
    <header className="sticky top-0 z-30 border-b border-[#dfe8e1] bg-white/90 backdrop-blur-xl">
      <div className="flex h-16 items-center justify-between px-5 xl:px-8">
        <p className="text-sm font-medium text-[#73827b]">
          Boa tarde, <span className="font-black text-[#0d2a1f]">Trader</span>
        </p>

        <div className="flex items-center gap-2">
          <button className="flex h-10 w-10 items-center justify-center rounded-full border border-[#dfe8e1] text-[#0d2a1f] transition hover:border-[#bfe8d3] hover:bg-[#f4f7f1]">
            <FiMoon className="h-5 w-5" />
          </button>
          <button className="relative flex h-10 w-10 items-center justify-center rounded-full border border-[#dfe8e1] text-[#0d2a1f] transition hover:border-[#bfe8d3] hover:bg-[#f4f7f1]">
            <FiBell className="h-5 w-5" />
            <span className="absolute right-2 top-2 h-2.5 w-2.5 rounded-full bg-[#20c77a] ring-2 ring-white" />
          </button>
          <button className="flex h-10 w-10 items-center justify-center rounded-full bg-[#20c77a] text-sm font-black text-[#03120e]">
            T
          </button>
          <button className="flex h-10 w-10 items-center justify-center rounded-full border border-[#dfe8e1] text-[#73827b] transition hover:border-[#bfe8d3] hover:text-[#0d2a1f]">
            <FiLogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default function Dashboard({ preview = false }: DashboardProps) {
  // const userToken = getUserToken();
  const { token } = useAuth();
  // const apiToken = Cookies.get("token");
  const baseUrl = process.env.REACT_APP_BASE_API_URL;

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSignal, setSelectedSignal] = useState(null);
  const [allPredictionData, setAllPredictionData] = useState({});
  const [predictionData, setPredictionData] = useState([]);
  const [globalMapping, setGlobalMapping] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);

  const [selectedTimeZone, setSelectedTimeZone] = useState(null);

  const [filters, setFilters] = useState({
    pair: "ALL",
    timeframe: null,
    signalType: null,
  });

  /* -----------------------------------------------------------
     REDIRECT NON-LOGGED USER
  ------------------------------------------------------------ */
  // useEffect(() => {
  //   if (!userToken) navigate("/login");
  // }, [navigate, userToken]);

  // /* -----------------------------------------------------------
  //    LOAD USER TIMEZONE
  // ------------------------------------------------------------ */
  // useEffect(() => {
  //   const offset = -new Date().getTimezoneOffset() / 60;
  //   const tz = timezones.find((tz) => tz.code === offset);
  //   if (tz) setSelectedTimeZone(tz);
  // }, []);

  /* -----------------------------------------------------------
     LOAD USER TIMEZONE
  ------------------------------------------------------------ */
  useEffect(() => {
    const getTimezone = () => {
      const offset = -new Date().getTimezoneOffset() / 60
      const matched = timezones.find(tz => tz.code === offset)
      if (!matched) return null

      const stored = localStorage.getItem("dashboard_timezone")
      if (!stored) {
        localStorage.setItem("dashboard_timezone", JSON.stringify(matched))
        return matched
      }

      try {
        const parsed = JSON.parse(stored)
        // Verifica se é um timezone válido
        return timezones.find(tz => tz.code === parsed.code) ?? matched
      } catch (error) {
        console.error("Erro ao parsear timezone do localStorage:", error)
        localStorage.setItem("dashboard_timezone", JSON.stringify(matched))
        return matched
      }
    }

    const tz = getTimezone()
    if (tz) setSelectedTimeZone(tz)
  }, [])

  /* -----------------------------------------------------------
     HANDLE TIMEZONE CHANGE
  ------------------------------------------------------------ */
  const handleTimeZoneChange = (newTimeZone) => {
    setSelectedTimeZone(newTimeZone)
    localStorage.setItem("dashboard_timezone", JSON.stringify(newTimeZone))
    // Forçar atualização das cards
    if (Object.keys(allPredictionData).length > 0) {
      handleFilterChange(filters)
    }
  }

  /* -----------------------------------------------------------
     PAIR MAPPING — FINAL E ESTÁVEL
  ------------------------------------------------------------ */
  const pairMapping2 = useCallback(async () => {
    try {
      const token = getUserToken();
      if (!token) return {};

      const res = await fetch(`${baseUrl}/api/pairs`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) return {};

      const data = await res.json();
      const results = data.results || data.items || data;

      const mapping = {};

      if (Array.isArray(results)) {
        results.forEach((item) => {
          const name = item.asset || item.pair || item.pair_name;
          const id =
            item.sort ??
            item.id ??
            item.pair_id ??
            item.index ??
            item.order ??
            null;

          if (name && id !== null) mapping[name] = Number(id);
        });
      }

      // console.log("PAIR MAPPING:", mapping);

      return mapping;
    } catch (err) {
      console.log("PAIR MAPPING ERROR:", err);
      return {};
    }
  }, [baseUrl]);

  /* -----------------------------------------------------------
       CONVERT TIME WITH TIMEZONE (Com offset correto)
    ------------------------------------------------------------ */
  const convertTimeWithTimezone = (timestamp, targetTimezone) => {
    if (!timestamp || !targetTimezone) return "—";

    try {
      // Remove offset se existir
      const cleanTs = timestamp.toString().replace('+00:00', '').trim();

      // Cria a data - IMPORTANTE: Assumindo que o timestamp da API está em UTC
      const date = new Date(cleanTs.replace(' ', 'T') + 'Z');

      if (isNaN(date.getTime())) {
        return cleanTs;
      }

      // Calcula a diferença entre o timezone atual do navegador e o timezone selecionado
      const browserOffset = -date.getTimezoneOffset() / 60; // offset do navegador em horas
      const targetOffset = targetTimezone.code; // offset do timezone selecionado

      console.log(`Browser offset: ${browserOffset}h, Target offset: ${targetOffset}h`);

      // Ajusta a data: se o timestamp é UTC, e queremos ver em GMT+2 (Maputo),
      // precisamos adicionar 2 horas. Mas se o navegador já está em GMT+2,
      // o Date já vai mostrar correto.

      // Se o timestamp é UTC (como indicado pelo +00:00), então:
      // Para converter para outro timezone: UTC + offset
      const adjustedDate = new Date(date.getTime() + (targetOffset * 60 * 60 * 1000));

      // Formata
      const day = String(adjustedDate.getUTCDate()).padStart(2, '0');
      const month = String(adjustedDate.getUTCMonth() + 1).padStart(2, '0');
      const year = adjustedDate.getUTCFullYear();
      const hours = String(adjustedDate.getUTCHours()).padStart(2, '0');
      const minutes = String(adjustedDate.getUTCMinutes()).padStart(2, '0');
      const seconds = String(adjustedDate.getUTCSeconds()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    } catch (error) {
      console.error("Erro na conversão:", error);
      return String(timestamp);
    }
  };

  /* -----------------------------------------------------------
     SAFE DATE (mantém compatibilidade)
  ------------------------------------------------------------ */
  const safeDate = (ts) => {
    if (!ts) return "—"
    try {
      const d = new Date(ts)
      if (!isNaN(d.getTime())) return d.toLocaleString()

      const d2 = new Date(ts.replace(" ", "T"))
      if (!isNaN(d2.getTime())) return d2.toLocaleString()

      return ts
    } catch {
      return ts
    }
  }

  
  /* -----------------------------------------------------------
       MAP API → CARD (com timezone)
    ------------------------------------------------------------ */
  const mapApiToCard = useCallback(
    (item, pairKey) => {
      if (!item) return null

      const asset =
        item.asset || item.pair || item.pair_name || pairKey || "UNKNOWN"

      const prediction = item.prediction || {}
      const lastResults = item.last_results || item.results || []

      const signal =
        prediction.predicted_signal ||
        prediction["Predicted Signal"] ||
        (lastResults[0]?.predicted_signal ||
          lastResults[0]?.["Predicted Signal"]) ||
        "PUT"

      const ts =
        prediction.timestamp ||
        prediction.Timestamp ||
        lastResults[0]?.timestamp ||
        lastResults[0]?.Timestamp

        
      // console.log({prediction})

      return {
        pair: asset,
        pairNumber: asset,
        expiry: "5 min",
        time: selectedTimeZone ? convertTimeWithTimezone(ts, selectedTimeZone) : safeDate(ts),
        originalTimestamp: ts, // Guarda o timestamp original para referência
        signalType: signal,
        successRate: Math.round((prediction.success_rate ?? 0) * 100),
        marketCondition: {
          label: item.reliable ? "Green - Trade" : "High Risk",
          color: item.reliable ? "green" : "red",
          percent:
            Math.round(
              (prediction["Probability of Success"] ??
                prediction.probability_of_success ??
                0) * 100
            ) || 50,
        },
        lastResults: lastResults.map((r) => ({
          Timestamp: selectedTimeZone
            ? convertTimeWithTimezone(r.Timestamp || r.timestamp, selectedTimeZone)
            : safeDate(r.Timestamp || r.timestamp),
          "Predicted Signal":
            r["Predicted Signal"] || r.predicted_signal || "PUT",
          "Market Signal": r["Market Signal"] || r.market_signal || "PUT",
          originalTimestamp: r.Timestamp || r.timestamp, // Guarda original
        })),
        timezone: selectedTimeZone?.label || "Local",
      }
    },
    [globalMapping, selectedTimeZone] // Adiciona selectedTimeZone como dependência
  )

  /* -----------------------------------------------------------
     FETCH LATEST PREDICTIONS
  ------------------------------------------------------------ */
  const fetchLatestPredictions = useCallback(async () => {
    try {
      // const token = getUserToken();
      if (!token) return;

      const res = await fetch(`${baseUrl}/api/predictions/latest?pair=all`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const errorText = !res.ok ? await res.json().catch(() => null) : null;

      if (errorText?.errorCode === "BB403") {
        setError(
          <div>
            <strong>{errorText.message || "Subscription required"}</strong>
            <p className="mt-2">
              You need an active plan to access predictions.{' '}
              <Link to="/price" className="text-blue-400 hover:text-blue-300 underline">
                Click here to view available plans
              </Link>
            </p>
          </div>
        );
        return;
      }

      if (!res.ok) {
        setError("Failed to load predictions");
        return;
      }

      const data = await res.json();
      // console.log("PREDICTIONS RAW:", data);

      let normalized = {};

      if (Array.isArray(data.results)) {
        data.results.forEach((r) => {
          const key = r.asset || r.pair || `pair_${Math.random()}`;
          normalized[key] = r;
        });
      } else if (Array.isArray(data)) {
        data.forEach((r) => {
          const key = r.asset || r.pair || `pair_${Math.random()}`;
          normalized[key] = r;
        });
      } else if (typeof data === "object") {
        Object.entries(data).forEach(([k, v]) => {
          if (v?.results?.[0]) {
            const asset = v.results[0].asset || v.results[0].pair || k;
            normalized[asset] = v.results[0];
          }
        });
      }

      setAllPredictionData(normalized);

      const cards = Object.entries(normalized)
        .map(([k, v]) => mapApiToCard(v, k))
        .filter(Boolean);

      setPredictionData(cards);
      setError(null);
    } catch (err) {
      console.log("FETCH PREDICTIONS ERR:", err);
      setError("Error loading predictions");
    } finally {
      setLoading(false);
    }
  }, [baseUrl, mapApiToCard]);

  /* -----------------------------------------------------------
     INIT LOAD
  ------------------------------------------------------------ */
  useEffect(() => {
    let active = true;

    const start = async () => {
      if (preview) {
        setPredictionData(PREVIEW_SIGNALS);
        setAllPredictionData(
          PREVIEW_SIGNALS.reduce((acc, signal) => {
            acc[signal.pair] = signal;
            return acc;
          }, {})
        );
        setError(null);
        setLoading(false);
        return;
      }

      const map = await pairMapping2();
      if (active) setGlobalMapping(map);

      await fetchLatestPredictions();

      intervalRef.current = setInterval(fetchLatestPredictions, 60000);
    };

    start();

    return () => {
      active = false;
      clearInterval(intervalRef.current);
    };
  }, [preview]);

  /* -----------------------------------------------------------
     FILTER HANDLER — FINAL
  ------------------------------------------------------------ */
  const handleFilterChange = useCallback(
    (newFilters) => {
      setFilters(newFilters);

      if (preview) {
        const cards = PREVIEW_SIGNALS.filter((signal) => {
          const pairMatches =
            !newFilters.pair ||
            newFilters.pair === "ALL" ||
            signal.pair === newFilters.pair;
          const signalMatches =
            !newFilters.signalType || signal.signalType === newFilters.signalType;
          const timeframeMatches =
            !newFilters.timeframe || signal.expiry === newFilters.timeframe;
          const confidenceMatches =
            !newFilters.confidence || Number(signal.successRate || 0) >= newFilters.confidence;

          return pairMatches && signalMatches && timeframeMatches && confidenceMatches;
        });

        setPredictionData(cards);
        return;
      }

      if (!allPredictionData) return;

      if (newFilters.pair === "ALL") {
        const cards = Object.entries(allPredictionData)
          .map(([k, v]) => mapApiToCard(v, k))
          .filter(Boolean)
          .filter((card) => {
            const signalMatches =
              !newFilters.signalType || card.signalType === newFilters.signalType;
            const timeframeMatches =
              !newFilters.timeframe || card.expiry === newFilters.timeframe;
            const confidenceMatches =
              !newFilters.confidence || Number(card.successRate || 0) >= newFilters.confidence;

            return signalMatches && timeframeMatches && confidenceMatches;
          });
        setPredictionData(cards);
        return;
      }

      const pairName = newFilters.pair;
      const pairItem = allPredictionData[pairName];

      if (!pairItem) {
        setPredictionData([]);
        return;
      }

      const card = mapApiToCard(pairItem, pairName);
      if (newFilters.confidence && Number(card?.successRate || 0) < newFilters.confidence) {
        setPredictionData([]);
        return;
      }
      setPredictionData([card]);
    },
    [allPredictionData, mapApiToCard, preview]
  );
  useEffect(() => {
    if (preview) return;

    console.log("Timezone ou allPredictionData mudou", selectedTimeZone, allPredictionData);
    if (Object.keys(allPredictionData).length === 0) return

    const cards = Object.entries(allPredictionData)
      .map(([k, v]) => mapApiToCard(v, k))
      .filter(Boolean)

    setPredictionData(cards)

    if (filters.pair !== "ALL") {
      handleFilterChange(filters)
    }
  }, [selectedTimeZone, allPredictionData])
  /* -----------------------------------------------------------
     LOADING STATE
  ------------------------------------------------------------ */
  if (loading) {
    return (
      <div className="min-h-screen bg-[#f4f7f1]">
        <DashboardSidebar preview={preview} />
        <main className="xl:pl-[270px]">
          <DashboardTopbar />
          <div className="pt-32 text-center text-[#73827b]">
            Loading signals...
          </div>
        </main>
      </div>
    );
  }

  const sourceSignals = preview ? PREVIEW_SIGNALS : Object.keys(allPredictionData).map((pair) => ({ pair }));
  const availablePairs = Array.from(new Set(sourceSignals.map((signal) => signal?.pair).filter(Boolean)));

  /* -----------------------------------------------------------
     MAIN RENDER
  ------------------------------------------------------------ */
  return (
    <div className="min-h-screen bg-[#f4f7f1] text-[#0d2a1f]">
      <DashboardSidebar preview={preview} />

      <main className="min-h-screen xl:pl-[270px]">
        <DashboardTopbar />

        <div className="mx-auto max-w-[1240px] px-5 py-8 xl:px-7">
          <div className="mb-7 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="text-4xl font-black tracking-[-0.04em] text-[#0d2a1f]">
                Sinais
              </h1>
              <p className="mt-2 text-base font-medium text-[#73827b]">
                Feed de sinais de opcoes binarias com confianca, direcao e expiracao em tempo real.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-[#dff6ea] px-4 py-2 text-sm font-black text-[#087a45]">
                <FiRadio className="h-4 w-4" />
                Ao vivo
              </span>
              <span className="rounded-full bg-[#fff0d8] px-4 py-2 text-sm font-black text-[#f08700]">
                IA + certeza
              </span>
            </div>
          </div>

          <SimplifiedFilters
            onFilterChange={handleFilterChange}
            selectedTimeZone={selectedTimeZone}
            setSelectedTimeZone={setSelectedTimeZone}
            onTimeZoneChange={handleTimeZoneChange}
            availablePairs={availablePairs}
          />

          <div className="mt-6">
            <div className="mb-5 flex items-center justify-between">
              <span className="text-sm font-bold text-[#73827b]">
                {predictionData.length} sinais
              </span>
              <span className="rounded-full bg-[#fff0d8] px-3 py-1.5 text-xs font-black text-[#f08700]">
                Probabilidade da IA + certeza
              </span>
            </div>

            {error && (
              <motion.div className="mb-6 rounded-2xl border border-red-200 bg-red-50 p-4 text-red-700">
                {error}
              </motion.div>
            )}

            {!error && predictionData.length === 0 && (
              <div className="mb-6 rounded-2xl border border-[#dfe8e1] bg-white p-8 text-center text-[#73827b]">
                Nenhum sinal disponivel com os filtros selecionados.
              </div>
            )}

            {predictionData.length > 0 && (
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
                {predictionData.map((s, idx) => (
                  <SignalCard
                    key={`${s.pair}-${idx}`}
                    signal={s}
                    onViewDetails={() => {
                      setSelectedSignal(s);
                      setModalOpen(true);
                    }}
                  />
                ))}
              </div>
            )}
          </div>

          {modalOpen && selectedSignal && (
            <AnalyticsModal
              isOpen={modalOpen}
              onClose={() => setModalOpen(false)}
              pairNumber={selectedSignal.pairNumber}
              apiToken={token}
              fallbackLastResults={selectedSignal.lastResults}
              selectedTimeZone={selectedTimeZone}
            />
          )}
        </div>
      </main>
    </div>
  );
}
